<template>
	<div v-if="isUserAllowedInLevel5or6 && isAuthenticatedUserInGroupAdmin">
		<BaseHeader :title="$t('edit_opening_hours').toString()" />
		<div v-if="!loading" class="m-8">
			<div class="w-full flex flex-row md:gap-8">
				<TimeInput
					:disabled="monday_closed"
					ref="BaseInput.monday_from"
					placeholder=" "
					:label="$t('monday_from')"
					class="w-1/4"
					:required="!monday_closed"
					v-model="openingHours.monday_open"
				/>
				<TimeInput
					:disabled="monday_closed"
					ref="BaseInput.monday_until"
					placeholder=" "
					:label="$t('monday_until')"
					class="w-1/4 "
					:required="!monday_closed"
					v-model="openingHours.monday_close"
				/>
				<BaseCheckbox class="mt-8" :label="$t('is_closed')" v-model="monday_closed" />
			</div>
			<div class="w-full flex flex-row md:gap-8">
				<TimeInput
					ref="BaseInput.tuesday_from"
					placeholder=" "
					:disabled="tuesday_closed"
					:label="$t('tuesday_from')"
					:required="!tuesday_closed"
					class="w-1/4"
					v-model="openingHours.tuesday_open"
				/>
				<TimeInput
					ref="BaseInput.tuesday_until"
					placeholder=" "
					:disabled="tuesday_closed"
					:label="$t('tuesday_until')"
					:required="!tuesday_closed"
					class="w-1/4 "
					v-model="openingHours.tuesday_close"
				/>
				<BaseCheckbox class="mt-8" :label="$t('is_closed')" v-model="tuesday_closed" />
			</div>
			<div class="w-full flex flex-row md:gap-8">
				<TimeInput
					ref="BaseInput.wednesday_from"
					placeholder=" "
					:disabled="wednesday_closed"
					:label="$t('wednesday_from')"
					:required="!wednesday_closed"
					class="w-1/4"
					v-model="openingHours.wednesday_open"
				/>
				<TimeInput
					ref="BaseInput.wednesday_until"
					placeholder=" "
					:disabled="wednesday_closed"
					:label="$t('wednesday_until')"
					:required="!wednesday_closed"
					class="w-1/4 "
					v-model="openingHours.wednesday_close"
				/>
				<BaseCheckbox class="mt-8" :label="$t('is_closed')" v-model="wednesday_closed" />
			</div>
			<div class="w-full flex flex-row md:gap-8">
				<TimeInput
					ref="BaseInput.thursday_from"
					placeholder=" "
					:disabled="thursday_closed"
					:label="$t('thursday_from')"
					:required="!thursday_closed"
					class="w-1/4"
					v-model="openingHours.thursday_open"
				/>
				<TimeInput
					ref="BaseInput.thursday_until"
					placeholder=" "
					:disabled="thursday_closed"
					:label="$t('thursday_until')"
					:required="!thursday_closed"
					class="w-1/4"
					v-model="openingHours.thursday_close"
				/>
				<BaseCheckbox class="mt-8" :label="$t('is_closed')" v-model="thursday_closed" />
			</div>
			<div class="w-full flex flex-row md:gap-8">
				<TimeInput
					ref="BaseInput.friday_from"
					placeholder=" "
					:disabled="friday_closed"
					:label="$t('friday_from')"
					:required="!friday_closed"
					class="w-1/4"
					v-model="openingHours.friday_open"
				/>
				<TimeInput
					ref="BaseInput.friday_until"
					placeholder=" "
					:disabled="friday_closed"
					:label="$t('friday_until')"
					:required="!friday_closed"
					class="w-1/4"
					v-model="openingHours.friday_close"
				/>
				<BaseCheckbox class="mt-8" :label="$t('is_closed')" v-model="friday_closed" />
			</div>
			<div class="w-full flex flex-row md:gap-8">
				<TimeInput
					ref="BaseInput.saturday_from"
					placeholder=" "
					:disabled="saturday_closed"
					:label="$t('saturday_from')"
					:required="!saturday_closed"
					class="w-1/4"
					v-model="openingHours.saturday_open"
				/>
				<TimeInput
					ref="BaseInput.saturday_until"
					placeholder=" "
					:disabled="saturday_closed"
					:label="$t('saturday_until')"
					:required="!saturday_closed"
					class="w-1/4"
					v-model="openingHours.saturday_close"
				/>
				<BaseCheckbox class="mt-8" :label="$t('is_closed')" v-model="saturday_closed" />
			</div>
			<div class="w-full flex flex-row md:gap-8">
				<TimeInput
					ref="BaseInput.sunday_from"
					placeholder=" "
					:disabled="sunday_closed"
					:label="$t('sunday_from')"
					:required="!sunday_closed"
					class="w-1/4"
					v-model="openingHours.sunday_open"
				/>
				<TimeInput
					ref="BaseInput.sunday_until"
					placeholder=" "
					:disabled="sunday_closed"
					:label="$t('sunday_until')"
					:required="!sunday_closed"
					class="w-1/4"
					v-model="openingHours.sunday_close"
				/>
				<BaseCheckbox class="mt-8" :label="$t('is_closed')" v-model="sunday_closed" />
			</div>
		</div>
		<Footer class="mx-8 justify-center" :is-back-button="false">
			<template #continueButton>
				<SaveButton @click="save" :disabled="disableButton" class="w-16 btn-blue">
					{{ $t('general.save') }}
				</SaveButton>
			</template>
		</Footer>
	</div>
	<Forbidden v-else />
</template>

<script>
import Validate from '@/mixins/Validate';
import { RepairshopsApiFactory } from '@/api/generated';
import apiDefaults from '@/api/defaultConfiguration';
import TimeInput from '@/components/forms/inputs/TimeInput.vue';
import BaseHeader from '@/components/navigation/BaseHeader.vue';
import Footer from '@/components/damagecases/Footer';
import SaveButton from '@/components/forms/buttons/SaveButton.vue';
import BaseCheckbox from '@/components/forms/inputs/BaseCheckbox.vue';
import Authentication from '@/mixins/Authentication';
import Forbidden from '@/views/default/Forbidden.vue';

export default {
	name: 'OpeningHours',
	components: { Forbidden, BaseCheckbox, SaveButton, BaseHeader, TimeInput, Footer },
	mixins: [Validate, Authentication],
	data() {
		return {
			loading: false,
			id: null,
			monday_closed: false,
			tuesday_closed: false,
			wednesday_closed: false,
			thursday_closed: false,
			friday_closed: false,
			saturday_closed: false,
			sunday_closed: false,
			openingHours: {
				monday_open: null,
				monday_close: null,
				tuesday_open: null,
				tuesday_close: null,
				wednesday_open: null,
				wednesday_close: null,
				thursday_open: null,
				thursday_close: null,
				friday_open: null,
				friday_close: null,
				saturday_open: null,
				saturday_close: null,
				sunday_open: null,
				sunday_close: null,
			},
			disableButton: false,
		};
	},
	methods: {
		save() {
			this.disableButton = true;
			for (const key in this.openingHours) {
				if (this.openingHours[key] === '') {
					this.openingHours[key] = null;
				}
			}
			RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.openinghoursIdPut(this.id, this.openingHours)
				.then(response => {
					this.$store.commit('setConfirmLeaving', false);
					this.disableButton = false;
					this.$swal(this.$t('general.success').toString(), this.$t('general.changes_saved').toString(), 'success');
					this.fetchOpeningHours();
				})
				.catch(error => {
					console.log(error);
					this.$swal(this.$t('general.error').toString(), this.$t('general.changes_not_saved').toString(), 'error');
				});
		},
		fetchOpeningHours() {
			RepairshopsApiFactory(apiDefaults.config(), apiDefaults.basePath, apiDefaults.axios)
				.openinghoursGet()
				.then(response => {
					this.id = response.data.data.id;
					const tempObject = response.data.data.times;
					for (const key in tempObject) {
						const value = tempObject[key];
						if (value !== null) {
							tempObject[key] = value.slice(0, -3);
						} else {
							switch (key) {
								case 'monday_open':
									this.monday_closed = true;
									break;
								case 'tuesday_open':
									this.tuesday_closed = true;
									break;
								case 'wednesday_open':
									this.wednesday_closed = true;
									break;
								case 'thursday_open':
									this.thursday_closed = true;
									break;
								case 'friday_open':
									this.friday_closed = true;
									break;
								case 'saturday_open':
									this.saturday_closed = true;
									break;
								case 'sunday_open':
									this.sunday_closed = true;
									break;
							}
						}
					}
					this.openingHours = tempObject;
					this.loading = false;
					this.disableButton = false;
				});
		},
	},
	watch: {
		monday_closed: function(newValue) {
			if (newValue) {
				this.openingHours.monday_open = '';
				this.openingHours.monday_close = '';
			} else {
				this.openingHours.monday_open = '08:00';
				this.openingHours.monday_close = '16:00';
			}
		},
		tuesday_closed: function(newValue) {
			if (newValue) {
				this.openingHours.tuesday_open = '';
				this.openingHours.tuesday_close = '';
			} else {
				this.openingHours.tuesday_open = '08:00';
				this.openingHours.tuesday_close = '16:00';
			}
		},
		wednesday_closed: function(newValue) {
			if (newValue) {
				this.openingHours.wednesday_open = '';
				this.openingHours.wednesday_close = '';
			} else {
				this.openingHours.wednesday_open = '08:00';
				this.openingHours.wednesday_close = '16:00';
			}
		},
		thursday_closed: function(newValue) {
			if (newValue) {
				this.openingHours.thursday_open = '';
				this.openingHours.thursday_close = '';
			} else {
				this.openingHours.thursday_open = '08:00';
				this.openingHours.thursday_close = '16:00';
			}
		},
		friday_closed: function(newValue) {
			if (newValue) {
				this.openingHours.friday_open = '';
				this.openingHours.friday_close = '';
			} else {
				this.openingHours.friday_open = '08:00';
				this.openingHours.friday_close = '16:00';
			}
		},
		saturday_closed: function(newValue) {
			if (newValue) {
				this.openingHours.saturday_open = '';
				this.openingHours.saturday_close = '';
			} else {
				this.openingHours.saturday_open = '08:00';
				this.openingHours.saturday_close = '16:00';
			}
		},
		sunday_closed: function(newValue) {
			if (newValue) {
				this.openingHours.sunday_open = '';
				this.openingHours.sunday_close = '';
			} else {
				this.openingHours.sunday_open = '08:00';
				this.openingHours.sunday_close = '16:00';
			}
		},
	},
	mounted() {
		if (this.isUserAllowedInLevel5or6 && this.isAuthenticatedUserInGroupAdmin) {
			this.loading = true;
			this.disableButton = true;
			this.fetchOpeningHours();
		}
	},
};
</script>
